import React from 'react'
import { observer } from 'mobx-react'
import FormHeader from './FormHeader'
import useSettingsManager from '../hooks/use-settings-manager'
import usePortManager from '../hooks/use-port-manager'
import SVGIcon from '../helpers/icons'

function InputWrapper ({borderless = false, htag = 'h2', className = 'input-wrapper', grid = 'input-grid', name, children}) {
  const _name = name
  const settings_manager = useSettingsManager()
  const _settings = settings_manager.getInputSettings(name)
  const strings = typeof _settings === 'object' ? _settings : { title: name }

  const port_manager = usePortManager()
  const isValid = typeof name === 'string' ? port_manager.isValid(name) : null

  const renderChildren = () => {
    return React.Children.map(children, child => {
        if(child.type === 'ValidationError') {
            return React.cloneElement(child, {
                is_valid: isValid,
                name: (typeof child.props.name !== 'undefined') ? child.props.name : _name,
                parent: _name
            })
        } else {
            return React.cloneElement(child, {
                name: (typeof child.props.name !== 'undefined') ? child.props.name : _name,
                parent: _name
            })
        }
    })

  }

  return (
    <aside className={className} data-borderless={borderless} data-valid={isValid}>
      {!isValid && port_manager.hasValue(name) ? <figure className={'error'} aria-label="Form error"
                                                               title="Form error"><SVGIcon type={'warning'}
                                                                                           fill={'#D14243'}
                                                                                           className={'warning-icon'}/>
      </figure> : null}
      <FormHeader strings={strings} htag={htag}/>
      {
        grid ?
          <div className={grid}>
            {renderChildren()}
          </div>
          : renderChildren()
      }
    </aside>
  )
}

export default observer(InputWrapper)